import type { ReactNode } from 'react';
import {
    EmptyInfoCard,
    type EmptyInfoCardProps,
} from '@components/_molecules/InfoCards';

export function EmptyInfoCardTemplate(props: EmptyInfoCardProps): ReactNode {
    return <EmptyInfoCard {...props} />;
}
